import pieChart from "../../../../components/pieChart/pieChart";
import { connect } from "react-redux";

export default connect(state => ({
  showLegend: true,
  legendPosition: "right",
  clickablePie: true,
  data: state.firstRiders.firstTimeRiders.closingBreakdown
}))(pieChart);
